function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 9.079c.05 2.338.19 6.337.21 6.778.071.943.432 1.896.994 2.568.782.943 1.745 1.364 3.088 1.364 1.856.01 3.902.01 5.89.01 1.994 0 3.93 0 5.565-.01 1.324 0 2.317-.432 3.09-1.364.561-.672.922-1.635.973-2.568.02-.371.12-4.712.18-6.778H0z",
  fill: "#1163F0"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.245 13.384v1.294a.75.75 0 001.5 0v-1.294a.75.75 0 00-1.5 0z",
  fill: "#CAD9FF"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.211 12.556a.75.75 0 01-.827.546c-2.55-.357-4.989-1.261-7.047-2.62A.747.747 0 010 9.854V6.39c0-2.1 1.712-3.808 3.817-3.808h1.967a2.953 2.953 0 012.92-2.58h2.582a2.953 2.953 0 012.92 2.58h1.977A3.812 3.812 0 0119.99 6.39v3.466a.753.753 0 01-.336.627c-2.062 1.365-4.51 2.274-7.078 2.629a.75.75 0 01-.83-.558 1.805 1.805 0 00-1.756-1.354c-.842 0-1.557.546-1.779 1.357zM11.286 1.5H8.704c-.673 0-1.235.46-1.403 1.081h5.387a1.456 1.456 0 00-1.402-1.08z",
  fill: "#CAD9FF"
});
function SvgWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}
export default SvgWork;